var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.updateManufacturer(true)
          },
        },
      },
      [
        _c("div", { staticClass: "flex flex_gap" }, [
          _c("div", {}, [
            _c("label", [_vm._v("Название производителя")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newManufacturer.title,
                  expression: "newManufacturer.title",
                },
              ],
              staticClass: "form-control",
              attrs: { required: "", type: "text" },
              domProps: { value: _vm.newManufacturer.title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newManufacturer, "title", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("label", [_vm._v("Короткое описание")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newManufacturer.text,
                  expression: "newManufacturer.text",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.newManufacturer.text },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newManufacturer, "text", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mt-1 flex" }, [
          _c(
            "div",
            { staticClass: "flex-grow-1 pr-2" },
            [
              _c("label", [_vm._v("Контакты")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-info btn-xs",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.addPhone()
                    },
                  },
                },
                [_vm._v("добавить контакт")]
              ),
              _vm._v(" "),
              _vm._l(_vm.newManufacturer.data.phones, function (p, i) {
                return _c("div", { key: i, staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: p.phone,
                        expression: "p.phone",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "номер или email" },
                    domProps: { value: p.phone },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(p, "phone", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: p.comment,
                        expression: "p.comment",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "комментарий" },
                    domProps: { value: p.comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(p, "comment", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.addPhone(i)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                  ),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow-1" }, [
            _c("label", [_vm._v("Комментарий")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newManufacturer.data.comment,
                  expression: "newManufacturer.data.comment",
                },
              ],
              staticClass: "form-control",
              attrs: {
                placeholder: "Комментарии к производителю...",
                rows: "3",
              },
              domProps: { value: _vm.newManufacturer.data.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newManufacturer.data,
                    "comment",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right mt-1" },
          [
            _c("LoadingButton", {
              attrs: {
                title:
                  (_vm.newManufacturer?.id
                    ? "Обновить производителя"
                    : "Сохранить производителя") +
                  (this.onSelectManufacturer ? " и привязать к задаче" : ""),
                className: "btn btn-outline-success",
                type: "button",
                onClick: () => _vm.updateManufacturer(true),
                loading: _vm.saveLoading,
                color: _vm.$constants.SUCCESS_COLOR,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }